import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

interface LeftRightAnimationProps {
  children: ReactNode;
}

const LeftRightAnimationSize: React.FC<LeftRightAnimationProps> = ({ children }) => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: false,
  });

  const variants = {
    hidden: { opacity: 0, x: 25 },   // Come from right
    visible: { opacity: 1, x: 0 },    // In place
    exit: { opacity: 0, x: 25 },    // Exit to right
  };

  return (
    <motion.div
      ref={ref}
      variants={variants}
      initial="hidden"
      animate={inView ? 'visible' : 'exit'}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
};

export default LeftRightAnimationSize;